/**
 * globally accessable object so we don't pollute the global namespace on every page.
 *
 * Create properties and methods on the fly:
 *
 * app.data = app.data || []; // try to overwrite objects or use unique names, eg. app.regChildPgData = []
 *
 * app.data.push({'id': someId}); // use arrays as storage for lists
 *
 * app["object-"+someId] = .... // create objects by name dynamically if needed to avoid array looping
 *
 * @format
 */

if (top != self) {
    top.location.replace(self.location.href);
    alert("iframe detected");
}

window.app = window.app || {}; // don't overwrite existing var if already exists

// general utility functions that are ok on the global namespace

// redifine FALSY to exlude 0
function not(val) {
    return !val && val !== "0" && val !== 0; 
}
// global debug wrapper over console.log, turns off in production
//function debug(m) {
//    if (window.app.env.toLowerCase().indexOf("prd") < 0) {
//        console.log(m);
//    }
//}

// Polyfills
//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith#Polyfill
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

// setup some common stuff
$(function() {
    /* query ready function */
    // only global site-wide functionality here
    if ($('input[name="__RequestVerificationToken"]').length > 0) {
        var token = $('input[name="__RequestVerificationToken"]').val();
        $.ajaxSetup({
            headers: {
                'RequestVerificationToken': token
            }
        });
    }
    // add class sc 'suppress click' to stop double form submission
    $(document).on("click", ".sc", function(e) {
        e.preventDefault();
        $(this).prop("disabled", true);
        $(this)
            .closest("form")
            .get(0)
            .submit();
    });

    $('[data-toggle="tooltip"]').tooltip({
        placement: "auto",
        container: "body",
        trigger: "manual"
    });

    /* data-collapse logic */
    $("[data-collapse-target*='#']").on("click", function() {
        window.debug("collapse!");
        var $this = $(this);
        $($this.data("collapse-target")).slideToggle();
    });
    /* end data-collapse logic */

    $('[data-toggle="tooltip"]').mouseenter(function() {
        $(this).tooltip("show");
    });

    $('[data-toggle="tooltip"]').mouseleave(function() {
        $(this).tooltip("hide");
    });
    if ($("#EditAddressForm").length > 0) {
        $.fn.select2.defaults.set("theme", "bootstrap4"); // default theme for select2 dropdowns
    }
    $(".feedback").on(app.clickEvent, function(e) {
        e.preventDefault();
        e.stopPropagation();
        $("#feedbackModalLabel").html($(this).html());
        $(".modalspinner").show();
        console.log(window.location.origin + window.app.hrefPrefix() + "/" + window.app.currentLanguage() + "/home/feedbackview");
        $("#feedbackModal .feedback-container").load(
            window.app.hrefPrefix() + "/" + window.app.currentLanguage() + "/home/feedbackview",
            function() {
                $(".modalspinner").hide();
            }
        );

        $("#feedbackModal").modal({ 'backdrop': 'static', 'focus': true, 'show': true });
    });

    $("a.elink").prop("target", "_blank");

    $(document).on("click", ".feedbackbtn", function(e) {
        e.preventDefault();
        $(".feedback-container form").submit();
        return false;
    });

    // handle "open in a new tab scenarios for Contact and Feedback modals
    if (window.location.hash === "#contact") {
        $("#feedbackModalLabel").html($(".contactus").html());
        $("#feedbackModal").modal({ 'backdrop': 'static', 'focus': true, 'show': true });
    }
    if (window.location.hash === "#feedback") {
        $("#feedbackModalLabel").html($(".feedbacklink").html());
        $("#feedbackModal").modal({ 'backdrop': 'static', 'focus': true, 'show': true });
    }

    // feedback submit
    $(document).on("submit", ".feedback-container form", function() {
        //$(".feedback-container form").validate();
        var valid = true; //$(".feedback-container form").valid();

        var btn = $(".feedbackbtn");
        window.app.data = window.app.data || {};
        window.app.data.btnHtml = btn.html();
        if (valid) {
            btn.prop("disabled", true);
            btn.html("<i class='fas fa-spinner fa-spin'></i>");
            var jqxhr = $.ajax({
                url:
                    window.app.hrefPrefix() + "/" + window.app.currentLanguage() + "/data/Feedback",
                type: "POST",
                dataType: "json",
                data: {
                    EmailAddress: $(".feedback-container form #EmailAddress").val(),
                    Email: $(".feedback-container form #Email").val(),
                    Name: $(".feedback-container form #Name").val(),
                    Comments: $(".feedback-container form #Comments").val(),
                    PhoneNumber: $(".feedback-container form #PhoneNumber").val(),
                    __RequestVerificationToken: $(
                        ".feedback-container form input[name=__RequestVerificationToken]"
                    ).val()
                },
                error: function(xhr, status, error) {
                    btn.html(window.app.data.btnHtml);
                    btn.prop("disabled", false);
                    $(".feedback-container .errormsg").html(status + ": " + error);
                },
                success: function(data, status, xhr) {
                    if (data !== null && data !== undefined && data.result !== undefined) {
                        if (data.result) {
                            btn.html("<i class='fas fa-check'></i>");

                            $("#feedbackModal").modal("hide");
                            $("#redirectModal .modal-title").html(
                                $("#feedbackModal .modal-title").html()
                            );
                            $("#redirectModal").modal({ 'backdrop': 'static', 'focus': true, 'show': true });
                        } else {
                            debug(data);
                            var html = "<ul>";
                            for (var i = 0; i < data.msgs.length; i++) {
                                html = html + "<li>" + data.msgs[i] + "</li>";
                            }
                            html = html + "</ul>";
                            $(".feedback-container .errormsg").html(html);
                            btn.html(window.app.data.btnHtml);
                            btn.prop("disabled", false);
                        }
                    } else {
                        btn.html(window.app.data.btnHtml);
                        btn.prop("disabled", false);
                    }
                }
            });
        }
        return false;
    });

    $(document).on("hidden.bs.modal", "#feedbackModal", function() {
        var btn = $(".feedbackbtn");
        if (window.app.data !== undefined && window.app.data.btnHtml !== undefined) {
            btn.html(window.app.data.btnHtml);
        }

        btn.prop("disabled", false);
        $(".feedback-container form input, .feedback-container form textarea").val("");
        $(".feedback-container .errormsg").html("");
    });

    // global confirm code
    $(document).on("click", ".bsconfirm-btn", function(e) {
        e.preventDefault();
        if ($(this).hasClass("bsconfirm-cancel")) {
            $(document).trigger("bsconfirm.click", {
                id: $(this).data("id"),
                trigger: $(this).data("event"),
                result: false
            });
            $(".bsconfirm").popover("hide");
        } else if ($(this).hasClass("bsconfirm-ok")) {
            $(document).trigger("bsconfirm.click", {
                id: $(this).data("id"),
                trigger: $(this).data("event"),
                result: true
            });
            $(".bsconfirm").popover("hide");
        }
    });

    // global confirm code
    $(document).on("click", ".bsconfirm", function(e) {
        e.preventDefault();
        $(".bsconfirm").popover("hide");
        $(".bsconfirm").popover("dispose");

        $(this).popover({
            trigger: "manual",
            title: $(this).data("msg"),
            content:
                "<button data-id='" +
                $(this).data("id") +
                "' data-event='" +
                $(this).data("event") +
                "' class='btn btn-danger bsconfirm-btn bsconfirm-cancel'><i class='fas fa-ban'></i></button> <button data-id='" +
                $(this).data("id") +
                "' data-event='" +
                $(this).data("event") +
                "' class='btn btn-primary bsconfirm-btn bsconfirm-ok'><i class='fas fa-check'></i></button>",
            html: true
        });

        $(this).popover("show");
    });

    //track external links

    $(".elink").click(function() {
        gtag("event", "Clicks", {
            event_category: "External-Link",
            event_label: $(this).html()
        });
    });

    // show info label
    $(".bsinfo").on("click", function(e) {
        $(".bsinfo").popover("hide");
        $(".bsinfo").popover("dispose");

        $(this).popover({
            trigger: "manual",
            title: "",
            content:
                "<div class='bsinfo-c'><p class='bsinfo-c'>" + $(this).data("msg") + "</p></div>",
            html: true
        });
        $(this).popover("show");
    });

    // setup click handler after popup shown, others it gets the bubble event and never shows
    $(document).on("shown.bs.popover", function() {
        window.setTimeout(function() {
            $(document).on("click", app.closeBsInfo);
        }, 100);
    });
});

// Immediately Invoked Function Expression (https://developer.mozilla.org/en-US/docs/Glossary/IIFE)
(function(global) {
    var app = global.app;
    app.templates = {};
    // usable window height;

    // get a handlebars template, with simple caching.
    app.getTemplate = function getTemplate(t) {
        if (!window.app.templates[t]) {
            window.app.templates[t] = Handlebars.compile(document.getElementById(t).innerHTML);
        }
        return window.app.templates[t];
    };

    // get a localized label
    app.label = function label(str) {
        if (!app.labels[str]) return str;
        return app.labels[str][app.currentLanguage()];
    };

    // close the .bsinfo popup and remove document clickevent
    app.closeBsInfo = function(evt) {
        if (!$(evt.target).is(".bsinfo-c, .popover-body")) {
            $(".bsinfo").popover("hide");
            $(".bsinfo").popover("dispose");
            $(document).off("click", app.closeBsInfo);
        }
    };

    app.clickEvent = (function clickEvent() {
        // use this to toggle between touch/non-touch devices in event handlers
        // SIIF, use like this: .on(window.app.clickEvent, function(){}); ie. no ()
        if ("ontouchstart" in document.documentElement === true) return "touchstart";
        else return "click";
    })();

    app.hrefPrefix = function hrefPrefix() {
        if (!app.baseHrefPart || app.baseHrefPart == '/') app.baseHrefPart = "";
        return app.baseHrefPart;
        //if (window.location.href.indexOf("parentportal") > 0) {
        //    return "/parentportal";
        //}
        //return "";
    };

    app.IsLeftStreetType = function IsLeftStreetType(st) {
        if (st === null || st === undefined) st = "";
        return (
            " rue RUE Rue chemin Chemin CHEMIN ruelle Ruelle croissant avenue place CH ch Ch route Route ROUTE rt Rt RT Highway ".indexOf(
                " " + st.trim() + " "
            ) > -1
        );
    };
    app.userHasRole = function userHasRole(role) {
        if (app.db.tmp.user[role]) return true;
        else return false;
    };
    app.setUserRole = function setUserRole(role, hasRole) {
        app.db.tmp.user[role] = hasRole;
    };

    app.b64EncodeUnicode = function b64EncodeUnicode(str) {
        return btoa(
            encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
                return String.fromCharCode(parseInt(p1, 16));
            })
        );
    };

    app.b64DecodeUnicode = function b64DecodeUnicode(str) {
        return decodeURIComponent(
            Array.prototype.map
                .call(atob(str), function(c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );
    };

    app.parseMVCDate = function parseMVCDate(strDate) {
        // parse data format that aspnet sends via json
        // strDate = "/Date(1057287600000)/"

        if (strDate === null || strDate === undefined) return new Date();

        if (strDate.indexOf !== undefined && strDate.indexOf('/Date(') === 0) {
            var d = new Date(parseFloat(strDate.replace("/Date(", "").replace(")/", "")));
            return d;
        } else {
            return strDate;
        }

    };

    app.toHtmlDate = function toHtmlDate(d) {
        console.log(d);
        if (d === undefined || d === null) {
            d = new Date();
        } else if (d.indexOf !== undefined) {
            d = new Date(d); // parse the string
        }
        return d.toISOString().split("T")[0];
    };

    app.currentLanguage = function currentLanguage() {
        // redirect to same url but change language
        var path = window.location.pathname.toLowerCase();
        if (path.length === 0) {
            return "en";
        } else {
            return (path.indexOf("/fr/") >= 0 && path.indexOf("/en/") >= 0 && path.indexOf("/en/") < path.indexOf("/fr/")) || path.indexOf("/fr/") < 0 ? "en" : "fr";
        }
    };

    app.info = function info(msg, title, large) {
        if (title) {
            $("#infoModal .modal-title-text").html(title);
        }

        if (large) {
            $("#infoModal .modal-dialog").addClass("modal-lg");
        } else {
            $("#infoModal .modal-dialog").removeClass("modal-lg");
        }

        $("#infoModal .modal-body").html(msg);
        $("#infoModal").modal({ 'backdrop': 'static', 'focus': true, 'show': true });
    };

    app.alert = function info(msg, callback, title, large) {
        $("#infoModal").one("hide.bs.modal", function(e) {
            callback();
        });
        app.info(msg, title, large);
    };

    app.highlight = function highlight(el) {
        $(el).addClass("highlight");
        window.setTimeout(window.app.removeHightlight, 2000, el);
    };
    app.removeHightlight = function removeHightlight(el) {
        $(el).addClass("highlightOff");
        window.setTimeout(window.app.clearHightlight, 1000, el);
    };
    app.clearHightlight = function removeHightlight(el) {
        $(el).removeClass("highlight");
        $(el).removeClass("highlightOff");
    };

    app.validPhoneNumber = function validPhoneNumber(num) {
        return (
            num !== undefined &&
            !!num &&
            /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/gim.test(
                num
            ) &&
            (num + "").length >= 10
        );
    };

    app.validEmail = function validEmail(email) {
        return (
            email !== undefined &&
            !!email &&
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim.test(
                email
            )
        );
    };

    app.getCharFromEvent = function getCharFromEvent(e) {
        // keyboardCharMap is an array of arrays, with each inner
        // array having 2 columns - un-shifted, and shifted values.
        // iCol = 0 is the un-shifted value, while iCol=1 is the shifted value.
        // See the "keyboardCharMap", below, for printable characters.
        // MODIFY keyboardCharMap to suit your needs if you want
        //    more/less/different characters to be considered "printable".
        var iCol = 0;
        if (e.shiftKey) {
            iCol = 1;
        }
        var ch = app.keyboardCharMap[e.keyCode][iCol];
        if (ch !== "") {
            return ch;
        } else {
            // Optionally do things with non-printables,
            // like CR, ESC, Backspace, LF, Tab, Arrows, F1-F24, etc.
            // See the arrary "keyboardNameMap", below, for possible keys.

            var cmd = app.keyboardNameMap[e.keyCode];
            //console.log("cmd: '" + cmd + "'");
            return cmd;
        }
    };

    app.loadFrameOKCAllback = function() {};
    app.closeFrame = function closeFrame() {
        $("#frameModal").modal("hide");
    };
    app.loadFramVars = {};
    app.loadFrame = function loadFrame(options) {
        var href = options.href || null;
        var title = options.title || "";
        var showClose = options.title || false;
        var cancel = options.cancel || window.app.label("Close");
        var ok = options.ok || window.app.label("Save");
        var onCancel = options.onCancel || function() {};
        var onOk = options.onOk || function() {};
        var height = options.height || 300;
        var icon = options.icon || "far fa-edit";
        var closeOnly = options.closeOnly || false;

        app.loadFramVars["title"] = title;
        app.loadFramVars["height"] = height;

        $("#frameModal .modal-title span").html(title);
        if (!showClose) {
            $("#frameModal .close").hide();
        } else {
            $("#frameModal .close").show();
        }

        if (closeOnly) {
            $("#frameModal .btn-ok").hide();
        } else {
            $("#frameModal .btn-ok").show();
        }

        $("#frameModal .modal-title i.fa-spin").show();

        $("#frameModal .modal-title i.icon").addClass(icon);

        $("#frameModal").one("shown.bs.modal", function() {
            //$("#frameModal .modal-body iframe").on("load", function() {
            //    $("#frameModal .modal-title i").hide();
            //});

            $("#frameModal .modal-body iframe").prop("src", href);
            //$("#frameModal .btn-secondary").one("click", onCancel);
            $("#frameModal .btn-primary").on("click", app.onFrameModalSave);
            app.loadFrameOKCAllback = onOk;
        });
        $("#frameModal").one("hidden.bs.modal", function() {
            app.loadFrameAfterSave = false;
            app.closeFrameAfterSave = false;
            $("#frameModal .btn-primary").off("click", app.onFrameModalSave);
            app.loadFrameOKCAllback = function() {};
            $("#ajaxframe").prop("src", "");
            $("#frameModal").modal("dispose");
        });

        $("#ajaxframe").prop("height", height);
        $("#frameModal").modal({
            backdrop: "static",
            keyboard: true,
            focus: true,
            show: true
        });
    };
    app.loadFrameAfterSave = false;
    app.closeFrameAfterSave = false;

    $("#ajaxframe").on("load", function() {
        $("#frameModal .modal-title i.fa-spin").hide();
        app.adjustFrameModalHeight();
        if (app.loadFrameAfterSave) {
            app.loadFrameAfterSave = false;
            // if the iframe form is valid, get the data
            var data =
                $("#ajaxframe")[0].contentWindow.isValid === true
                    ? $("#ajaxframe")[0].contentWindow.data
                    : null;

            app.loadFrameOKCAllback(data);
        }
        if (app.closeFrameAfterSave && $("#ajaxframe")[0].contentWindow.isValid) {
            $("#frameModal").modal("hide");
        }
    });
    app.adjustFrameModalHeight = function() {
        var DIALOGHEIGHT = 269; // this is the smallest possible height of a #frameModal dialog

        $("#ajaxframe").height(window.innerHeight - DIALOGHEIGHT);

        $("#frameModal").modal("handleUpdate");
    };
    app.onFrameModalSave = function(e) {
        $("#frameModal .modal-title i.fa-spin").show();

        app.loadFrameAfterSave = true;
        app.closeFrameAfterSave = false;

        if ($(this).hasClass("btn-ok-close")) {
            app.closeFrameAfterSave = true;
        }

        $("#ajaxframe")[0]
            .contentWindow.document.getElementsByTagName("form")[0] 
            .submit();
    };

    app.is_gecko = /gecko/i.test(navigator.userAgent);
    app.is_ie = /MSIE/.test(navigator.userAgent);
    app.setSelectionRange = function(input, start, end) {
        if (app.is_gecko) {
            input.setSelectionRange(start, end);
        } else {
            // assumed IE
            var range = input.createTextRange();
            range.collapse(true);
            range.moveStart("character", start);
            range.moveEnd("character", end - start);
            range.select();
        }
    };

    app.getSelectionStart = function(input) {
        if (app.is_gecko) return input.selectionStart;
        var range = document.selection.createRange();
        var isCollapsed = range.compareEndPoints("StartToEnd", range) === 0;
        if (!isCollapsed) range.collapse(true);
        var b = range.getBookmark();
        return b.charCodeAt(2) - 2;
    };

    app.getSelectionEnd = function(input) {
        if (app.is_gecko) return input.selectionEnd;
        var range = document.selection.createRange();
        var isCollapsed = range.compareEndPoints("StartToEnd", range) === 0;
        if (!isCollapsed) range.collapse(false);
        var b = range.getBookmark();
        return b.charCodeAt(2) - 2;
    };

    app.inputKey = function(input, ev) {
        setTimeout(function() {
            document.getElementById("selStart").value = app.getSelectionStart(input);
            document.getElementById("selEnd").value = app.getSelectionEnd(input);
        }, 20);
    };
    app.doSelect = function(start, end, el) {
        var input = el[0];
        input.focus();
        app.setSelectionRange(input, start, end);
    };
})(window);

$(function () {
    var lang = 'en';
    if (window.location.href.includes('/en/')) { lang = 'en' }
    else { lang = 'fr' }
   
    // datepickers, ensure the app object is already init
    $(".datepicker").datetimepicker({
        viewMode: "days",
        format: "YYYY-MM-DD",
        locale: lang + "-ca",
        keepOpen: false
    });
   
    $(".datepicker").on('blur', function () {
        $(".datepicker").datetimepicker("hide");
    });
    $(".input-group-text.date").on("click", function (e) {
      
        var id = $(e.target).attr('id');
        var el = $("body").find('#' + id);
        $(this)
            .parent()
            .prev(".datepicker")
            .datetimepicker("show");
    });
});
